import { LoginPage } from './../login/login';
import { CoreProvider } from './../../providers/core-service/core-service';
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';
import { Component } from '@angular/core';
import { NavController, NavParams, /*AlertController,*/ Keyboard } from 'ionic-angular';
import { IonicPage } from 'ionic-angular';

import { Week } from '../../model/Week';
import { User } from '../../model/User';
import { Subscription } from 'rxjs/Subscription';

/**
 * Generated class for the Weekly page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'weekly-view',
  templateUrl: 'week-view.html',
})
export class WeekViewPage {

  show_loading: boolean = true;
  labelWeek = 'Week';

  week_range: [Date, Date];
  week_differ: number = 0;
  week_binding: Week[] = [];

  weeksbinding: Subscription;

  private index_list: string[] = ['1_am', '1_pm', '2_am', '2_pm', '3_am', '3_pm',
    '4_am', '4_pm', '5_am', '5_pm', '6_am', '6_pm', '7_am', '7_pm']; //indice per settimana in ricerca

  prevShow: boolean = true;
  nextShow: boolean = true;

  userListToShow: User[] = [];

  private onNext = true;
  private onPrev = true;
  private checkNextOnce = false;
  private checkPrevOnce = false;

  showAutocomplete = false;
  showTravelEvidence = true;
  querySearch = '';
  autocomplete = [];
  manager = [];
  places = [];

  resultsEmpty: boolean = false;

  constructor(
    public navCtrl: NavController, public navParams: NavParams,
    public network: NetworkConnectionProvider,
    private keyboard: Keyboard,
    private coreService: CoreProvider
  ) {
    this.week_range = this.coreService.getWeekRange();
  }

  onSwipe(event: any) {
    if (event.direction == 4) {
      if (this.prevShow)
        this.moveToPreviousWeek();
    } else if (event.direction == 2) {
      if (this.nextShow)
        this.moveToNextWeek();
    }
  }

  loadActual() {
    this.coreService.getActualWeek();

    this.coreService.getofflineNextBlock().then(result => {
      this.nextShow = result;
    });

    this.coreService.getofflinePrevBlock().then(result => {
      this.prevShow = result;
    });
  }

  ionViewWillEnter() {

    let resetDate = this.navParams.get('resetDate');

    if (resetDate) {
      this.coreService.setSearchedData(null);
      this.coreService.resetWeekPointer(true);
    }

    //this.week_range = firebase.getWeekRange();

    this.weeksbinding = this.coreService.getWeek().subscribe(week => {
      if (this.coreService.getWeekDiffer() == 0) {
        this.labelWeek = 'Current Week';
      } else if (this.coreService.getWeekDiffer() < 0) {
        this.labelWeek = '' + this.coreService.getWeekDiffer() + ' Week';
      } else if (this.coreService.getWeekDiffer() > 0) {
        this.labelWeek = '+' + this.coreService.getWeekDiffer() + ' Week';
      }

      this.week_binding = week;

      this.week_range = this.coreService.getWeekRange();

      if (this.onNext && !this.checkNextOnce) {
        this.checkNextOnce = true;
        this.coreService.getofflineNextBlock().then(result => {
          this.nextShow = result;
          //console.log(result);
        });
      }


      if (this.onPrev && !this.checkPrevOnce) {
        this.checkPrevOnce = true;
        //console.log('heck prev');
        this.coreService.getofflinePrevBlock().then(result => {
          //console.log(result);
          this.prevShow = result;
        });
      }

      this.mantainResearch();

    });

    this.network.checkConnection().subscribe(online => {

      if ((online || this.coreService.initialized)) {
        if (!this.weeksbinding) {
          this.weeksbinding = this.coreService.getWeek().subscribe(week => {

            if (this.coreService.getWeekDiffer() == 0) {
              this.labelWeek = 'Current Week';
            } else if (this.coreService.getWeekDiffer() < 0) {
              this.labelWeek = '' + this.coreService.getWeekDiffer() + ' Week';
            } else if (this.coreService.getWeekDiffer() > 0) {
              this.labelWeek = '+' + this.coreService.getWeekDiffer() + ' Week';
            }

            this.week_binding = week;

            this.week_range = this.coreService.getWeekRange();

            if (this.onNext && !this.checkNextOnce) {
              this.checkNextOnce = true;
              this.coreService.getofflineNextBlock().then(result => {
                this.nextShow = result;
              });
            }


            if (this.onPrev && !this.checkPrevOnce) {
              this.checkPrevOnce = true;
              this.coreService.getofflinePrevBlock().then(result => {
                this.prevShow = result;
              });
            }

            this.mantainResearch();

          });
        } else {
          if (this.onNext)
            this.coreService.getofflineNextBlock().then(result => {
              this.nextShow = result;
            });

          if (this.onPrev)
            this.coreService.getofflinePrevBlock().then(result => {
              this.prevShow = result;
            });
        }

      } else if (!online && !this.coreService.initialized) {
        this.navCtrl.setRoot(LoginPage);
      }

    });
  }

  ionViewWillLeave() {
    // enable the root left menu when leaving this page
    this.weeksbinding.unsubscribe();
  }

  /**
   * Visualizza lo stato della settimana
   * @param key indice utente
   */
  checkUserPermission(key: string): boolean {
    if (this.coreService.userKey == key) return true;

    return false;
  }

  /**
   * Funzione autocompletamento
   * @param query stringa ricercata
   * {"autocomplete": ["Marcat Siro"], "managers": {"Marcat Siro": "year/2018/6/siromarcat@gmailcom"}, "places": {}}
   * {"autocomplete": ["Padua", "Padova"], "managers": {}, "places": {"Padua": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"], "Padova": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"]}}
   */
  onChange(query: string) {
    if (query.length > 2) {
      if (!this.network.verifyConnection()) {
        this.showAutocomplete = true;
        this.autocomplete = [];
        this.manager = [];

        for (let user of this.coreService.getUsersList()) {
          if (user.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
            this.autocomplete.push(user.name);
            this.manager[user.name] = '///' + user.key;
          }
        }

        this.places = [];

      } else {

        this.showAutocomplete = true;
        this.coreService.getAutocompleteSearchValues(query).first().subscribe(result => {
          this.autocomplete = result.autocomplete;

          this.manager = result.managers;
          this.places = result.places;
        });

      }
    } else {
      this.showAutocomplete = false;
      this.autocomplete = [];

      this.manager = [];
      this.places = [];
    }
  }

  /**
   * Controlla se la ricerca è attiva
   */
  isQuerying(): boolean {
    if (this.querySearch.length > 0) {
      return true;
    }

    //this.searchedPlace = '';
    return false;
  }

  /**
   * Salva indice autocomplete per ricera
   */
  setSearchQuery(txt: string) {
    this.querySearch = txt;

    this.showAutocomplete = false;

    this.submitSearch();
    //this.keyboard.close();
  }

  /**
   * Resetta campo ricerca
   */
  resetSearch() {

    this.coreService.setWeeksBinding();

    this.querySearch = '';
    this.autocomplete = [];
    this.manager = [];
    this.places = [];
    this.coreService.setSearchedData(null);

    this.resultsEmpty = false;
    // this.resetWeekVisible();

  }

  /**
   * Invia la ricera
   */
  submitSearch() {
    if (this.querySearch.length > 2) {
      this.showTravelEvidence = true;
      this.showAutocomplete = false;

      this.coreService.setSearchedData(null);
      this.mantainResearch();

    } else {

      this.showAutocomplete = true;
      this.autocomplete = [];
      this.manager = [];
      this.places = [];
      this.coreService.setSearchedData(null);
      this.resetWeekVisible();
    }
  }

  /**
   * Mantiene la ricera nello spostamento tra settimane
   */
  mantainResearch() {
    let findOnAutocomplete = false;
    let elementFind: string[] = [];

    let searchedData = null;
    searchedData = this.coreService.getSearchedData();

    if (searchedData) {
      //ricerca settata
      // this.hideWeek();

      let type = searchedData.type;
      this.querySearch = searchedData.query;

      if (type == 0) {
        this.setWeekVisible(searchedData.elements);


      } else if (type == 1) {
        this.coreService.getAutocompleteSearchValues(this.querySearch).first().subscribe(result => {
          this.showTravelEvidence = true;
          this.places = result.places;

          elementFind = [];
          let travelEvidence: any[] = [];
          if (this.places && (this.querySearch in this.places))
            for (let place of this.places[this.querySearch]) {

              let userkey = place.split('/')[3];
              let index = place.split('/')[4];

              let element_exist = false;
              for (let exist of elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                elementFind.push(userkey);
                travelEvidence[userkey] = [index];

              } else {
                travelEvidence[userkey].push(index);
              }

              findOnAutocomplete = true;
            }


          elementFind.sort();
          travelEvidence.sort();

          this.setWeekVisible(elementFind, this.showTravelEvidence, travelEvidence);

        });
      } else if (type == 2) {
        if (this.network.verifyConnection()) {
          this.coreService.getAutocompleteSearchGeneric(this.querySearch).toPromise().then(results => {
            elementFind = [];

            for (let user of results) {
              let userkey = user.split('/')[3];

              let element_exist = false;
              for (let exist of elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                elementFind.push(userkey);
              }
            }

            if (elementFind.length == 0) {
              this.setWeekVisible([]);
            } else {
              this.setWeekVisible(elementFind);
            }


          }).catch();
        } else {
          this.setWeekVisible(searchedData.elements);
        }

      }

    } else {

      //lanciare autocomplete per riottenere lista utenti da visualizzare con lista index per utente array
      if (this.querySearch.length > 0) {
        if (this.manager[this.querySearch]) {
          //se manager taglia le prime n lettere
          let userkey = this.manager[this.querySearch].split('/')[3];
          elementFind.push(userkey);
          findOnAutocomplete = true;

          this.coreService.setSearchedData({
            type: 0,
            query: this.querySearch,
            elements: elementFind
          });

          this.setWeekVisible(elementFind);

        } else if (this.places[this.querySearch]) {

          let travelEvidence: any[] = [];
          for (let place of this.places[this.querySearch]) {

            let userkey = place.split('/')[3];
            let index = place.split('/')[4];

            let element_exist = false;
            for (let exist of elementFind) {
              if (exist == userkey) {
                element_exist = true;
                break;
              }
            }

            if (!element_exist) {
              elementFind.push(userkey);
              travelEvidence[userkey] = [index];

            } else {
              travelEvidence[userkey].push(index);
            }

            findOnAutocomplete = true;
          }

          elementFind.sort();
          travelEvidence.sort();

          this.coreService.setSearchedData({
            type: 1,
            query: this.querySearch
          });

          this.setWeekVisible(elementFind, this.showTravelEvidence, travelEvidence);

        } else {

          if (this.network.verifyConnection()) {
            this.coreService.getAutocompleteSearchGeneric(this.querySearch).toPromise().then(results => {

              for (let user of results) {
                let endpoint = user.split('/')[3];
                let userkey = endpoint.split('/')[0];

                let element_exist = false;
                for (let exist of elementFind) {
                  if (exist == userkey) {
                    element_exist = true;
                    break;
                  }
                }

                if (!element_exist) {
                  elementFind.push(userkey);
                }
              }

              this.coreService.setSearchedData({
                type: 2,
                query: this.querySearch,
                elements: elementFind
              });

              if (elementFind.length == 0) {
                this.setWeekVisible([]);
              } else {
                this.setWeekVisible(elementFind);
              }
            }).catch();
          } else {

            //se manager taglia le prime n lettere
            for (let user of this.coreService.getUsersList()) {
              if (user.name.toLowerCase().indexOf(this.querySearch.toLowerCase()) > -1) {
                elementFind.push(user.key);
              }
            }

            findOnAutocomplete = true;

            this.coreService.setSearchedData({
              type: 2,
              query: this.querySearch,
              elements: elementFind
            });

            this.setWeekVisible(elementFind);
          }
        }
        //se place taglia le prime n lettere e mantiene valore key e mezza giornata se da evidenziare

      } else {

        this.resetWeekVisible();
      }

    }
  }

  /**
   * Filtra la settimana e nasconde gli utenti non desiderati
   */
  setWeekVisible(userList: string[], travelOnly: boolean = false, indexes?: any) {

    if (this.isQuerying()) {
      if (userList.length == 0)
        this.resultsEmpty = true;
      else
        this.resultsEmpty = false;
    } else {
      this.resultsEmpty = false;
    }

    if (!travelOnly) {
      for (let week of this.week_binding) {
        week.show = false;
        for (let user of userList) {
          if (user == week.user.key) {
            week.show = true;
            break;
          }
        }
      }
    } else {
      for (let week of this.week_binding) {
        week.show = false;
        for (let user of userList) {
          if (user == week.user.key) {

            for (let index of this.index_list) {
              if (indexes[user].indexOf(index) > -1) {
                week[index] = 'Travel';
              } else {
                week[index] = 'Bank Holiday';
              }
            }

            week.show = true;
            break;
          }
        }
      }
    }
    this.show_loading = false;
    //console.log('show week');
    this.keyboard.close();
  }

  /**
   * Configura la settimana per essere visibile
   */
  resetWeekVisible() {
    this.resultsEmpty = false;

    if (this.week_binding.length > 0) {
      for (let week of this.week_binding) {
        week.show = true;
      }
      //  console.log('reset week');
      this.show_loading = false;
    }

  }

  /**
   * Nasconde la settimana per la ricerca
   */
  hideWeek() {
    for (let week of this.week_binding) {
      week.show = false;
    }
  }

  moveToNextWeek(): void {
    this.onNext = true;
    this.prevShow = true;
    this.checkNextOnce = false;
    this.showTravelEvidence = false;
    this.show_loading = true;
    this.coreService.getNextWeek();
  }

  moveToPreviousWeek(): void {
    this.onPrev = true;
    this.nextShow = true;
    this.checkPrevOnce = false;
    this.showTravelEvidence = false;
    this.show_loading = true;
    this.coreService.getPrevWeek();
  }
}




// WEBPACK FOOTER //
// ./src/pages/week-view/week-view.ts